import React from 'react';
import ReactDOM from 'react-dom/client';
import "./App.css";

import { createBrowserRouter, RouterProvider } from 'react-router-dom'

import App from './App';
import { SobreNosotros } from './componentes/SobreNosotros';

const router = createBrowserRouter([
  { path: "/", element: <App /> },
  { path: "/nosotros", element: <SobreNosotros /> },
  
  /*{ path: "", element: <PageNotFound /> },
  { path: "*", element: <PageNotFound /> },
  { element: <PageNotFound /> }, */

])



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
